
<div #pageRoot class="main-black border-radius-bottom white-box m-0 page-content" [class.tab-mode]="isTabMode" [ngStyle]="cssVars"
	[style.height.px]="isTabMode ? tabModeHeight : null">
	<div class="page-header">
		<a [href]="siteURL" target="_blank"><img [src]="images.logo" alt="charglink BRM"></a>
		<button class="btn btn-primary" (click)="toggleBuzzer()">{{(buzzerEnabled ? 'charglink_brm.disable_buzzer' : 'charglink_brm.enable_buzzer') | translate}}</button>
	</div>

	<div class="page-container">
		<div #groupsViewport class="groups-viewport" *ngIf="!isExpiredToken" [@.disabled]="!animationsReady"
			[class.not-ready]="!isPageReady">
			<div class="page-loading" *ngIf="!isPageReady">
				<div class="spinner-border" role="status">
					<span class="sr-only">{{'g.loading' | translate}}...</span>
				</div>
			</div>
			<div class="groups-page" *ngFor="let page of visiblePages; trackBy: trackByPage" @pageTransition>
				<div class="group-card" *ngFor="let group of page.groups; trackBy: trackByGroup"
					[class.alert-active]="group.alertFlag" [@.disabled]="group.isFirstSeen">
					<!-- group with at least one Ready to Pick battery -->
					<div class="card-state" *ngIf="group.locations.length; else emptyGroup" @emptySwap>
						<div class="header">
							<img [src]="images.ready" alt="ready-to-use" class="status-image">
							<h4 class="group-name" [style.--text-scale]="group.nameFontScale">{{group.name}}</h4>
						</div>
						<div class="ready-list">
							<div class="ready-item" *ngFor="let location of group.locations; trackBy: trackByBattery" [class.is-new]="location.isNew" @readyBox>
								<span class="ready-badge">
									<svg class="ready-badge-icon" viewBox="0 0 16 16" aria-hidden="true">
										<circle cx="8" cy="8" r="6.8" fill="none" stroke="currentColor" stroke-width="1.5"></circle>
										<path d="M4.9 8.3l2.1 2.1 4.2-4.4" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path>
									</svg>
									{{'charglink_brm.ready_badge' | translate}}
								</span>
								<span class="location" [style.--text-scale]="location.fontScale">{{location.name}}</span>
							</div>
						</div>
						<img *ngIf="group.locations.length <= config.batteries.deviceImageBelowCount" [src]="images.batteryOn" alt="device" class="device-image">
					</div>

					<!-- group with no Ready to Pick battery -->
					<ng-template #emptyGroup>
						<div class="card-state without-location" @emptySwap>
							<div class="header">
								<img [src]="images.empty" alt="not-ready-to-use" class="status-image">
							</div>
							<p class="empty-message">{{'charglink_brm.not_ready_to_use' | translate:{"groupName": group.name} }}</p>
							<img *ngIf="config.batteries.deviceImageBelowCount > 0" [src]="images.batteryOff" alt="device" class="device-image">
						</div>
					</ng-template>
				</div>
			</div>
		</div>


		<div *ngIf="isExpiredToken" class="alert alert-danger" role="alert">
			<span>{{'charglink_brm.expired_token' | translate}}</span>
		</div>
	</div>
</div>
